import { oxford } from '../../utils/utils';
import { Image, ValImage } from '@valbuild/next';
interface SpeakerProps {
  name: string;
  roles?: string[];
  speakerImage?: Image;
}

const Speaker = ({ name, roles, speakerImage }: SpeakerProps) => {
  return (
    <div className="flex flex-col gap-5 tablet:flex-row laptop:flex-row">
      {speakerImage && (
        <ValImage
          alt={name}
          src={speakerImage}
          className="object-cover h-[142px] w-[142px]"
        />
      )}
      <div className="flex flex-col font-solina font-[600] text-[18px] leading-[30.6px] tracking-[3%] max-w-[351px]">
        <div>{name}</div>
        {roles && <div className="font-[200]">{oxford(roles)}</div>}
      </div>
    </div>
  );
};

export default Speaker;
